import React, { useEffect, useState, useMemo } from 'react';
import styles from './index.modules.scss';
import { NavBar, Tag, LoadingWrapper } from '@shakkerai/pro-components';
import { ImageDetail } from '../ImageDetail';
import { useTaskDetail } from '../../hooks/dataHooks';
import { useViewDetailState, useGenHistoryVisible } from '../../store/base';
import { eventBus } from '@starflow/app/helpers';
import { translate } from '@shakkerai/util-i18n';
import { mv } from '@shakkerai/report';

/**
 * 负责完成对数据详情的请求和差异化界面
 * 差异化包含：顶导、导入参数按钮等
 */
export const ImageDetailWrapper = () => {
  const { clearView, currentViewedGroupInfo, currentViewedImageIndex, source } = useViewDetailState();
  const { hideHistoryModelsBar } = useGenHistoryVisible();

  const { loadTaskDetail, taskDetail, isLoading, isLoadSuccess, isLoadFailed } = useTaskDetail(
    currentViewedGroupInfo?.generateId,
    source === 'album' ? currentViewedGroupInfo?.images[currentViewedImageIndex]?.groupId : -1,
  );

  useEffect(() => {
    if (currentViewedGroupInfo) {
      loadTaskDetail();
    }
  }, [currentViewedGroupInfo, loadTaskDetail]);

  const [currentInnerViewIndex, setCurrentInnerViewIndex] = useState(currentViewedImageIndex);

  const currentViewedImageInfo = useMemo(() => {
    if (taskDetail?.images && taskDetail?.images.length > 0) {
      return taskDetail.images[currentInnerViewIndex];
    } else {
      return null;
    }
  }, [currentInnerViewIndex, taskDetail]);

  useEffect(() => {
    if (currentViewedImageInfo) {
      mv('tool.history.detail', {
        image_uuid: currentViewedImageInfo?.outputId,
      });
    }
  }, [currentViewedImageInfo]);

  useEffect(() => {
    const refresh = () => {
      // false不展示loading动画
      loadTaskDetail(false);
    };

    eventBus.on('event_imageDetailRefresh', refresh);

    return () => {
      eventBus.off('event_imageDetailRefresh', refresh);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (taskDetail?.images?.length == 0) {
      clearView();
    }
  }, [taskDetail, clearView]);

  return (
    <div className={styles.imageViewWrapper}>
      <NavBar title={translate('history_image_info')} onBack={clearView} onClose={hideHistoryModelsBar}>
        <Tag
          type="primary2"
          iconClass="icon-a-proinusing"
          color="#222"
          style={{
            opacity: currentViewedImageInfo?.groupName ? 1 : 0,
          }}
        >
          {currentViewedImageInfo?.groupName}
        </Tag>
      </NavBar>

      <div className={styles.controlBar}>
        <LoadingWrapper
          isLoading={isLoading}
          isLoadSuccess={isLoadSuccess}
          isLoadFailed={isLoadFailed}
          onReload={loadTaskDetail}
        >
          {taskDetail && (
            <ImageDetail
              taskDetail={taskDetail}
              imageInfo={currentViewedImageInfo}
              updateImageIndex={(index) => setCurrentInnerViewIndex(index)}
            ></ImageDetail>
          )}
        </LoadingWrapper>
      </div>
    </div>
  );
};
